export { METHOD_TYPES } from 'constants/index'

export const DEFAULT_NAV_ITEMS = [
  'trending',
  'breaking',
  'new'
]

export const ORDER_TYPES = {
  LIMIT: 'limit',
  MARKET: 'market',
  SPLIT: 'split',
  MERGE: 'merge'
}

export const OUTCOME_TYPES = {
  YES: 'yes',
  NO: 'no'
}

export const ORDER_SIDES = {
  BID: 'bid',
  ASK: 'ask'
}

export const MAX_ORDER_SIZE = 500000

export const PREDICTION_MARKET_CHART_RANGE_OPTIONS = [
  { id: '1H', label: '1H', ms: 60 * 60 * 1000 },
  { id: '6H', label: '6H', ms: 6 * 60 * 60 * 1000 },
  { id: '1D', label: '1D', ms: 24 * 60 * 60 * 1000 },
  { id: '1W', label: '1W', ms: 7 * 24 * 60 * 60 * 1000 },
  { id: '1M', label: '1M', ms: 30 * 24 * 60 * 60 * 1000 },
  { id: 'ALL', label: 'ALL', ms: null }
]

export const PREDICTION_MARKET_CHART_PERCENTAGE_TICKS = [0, 20, 40, 60, 80, 100]

export const PREDICTION_MARKET_MULTI_SERIES_COLORS = [
  '#16a34a',
  '#2563eb',
  '#a855f7',
  '#ea580c',
  '#dc2626',
  '#0891b2',
  '#ca8a04'
]

export const PREDICTION_MARKET_OPTION_LINE_COLOR = '#2563eb'

export const ORDER_STATES = {
  OPEN: 'open',
  PARTIALLY_FILLED: 'partially_filled',
  FILLED: 'filled',
  FAILED: 'failed',
  REMOVED: 'removed',
  CLOSED: 'closed'
}

export const ORDER_TYPE_FILTERS = [
  { label: 'limit', value: ORDER_TYPES.LIMIT },
  { label: 'market', value: ORDER_TYPES.MARKET },
]

export const ORDER_SIDE_FILTERS = [
  { label: 'ask', value: ORDER_SIDES.ASK },
  { label: 'bid', value: ORDER_SIDES.BID },
]

export const ORDER_STATE_FILTERS = [
  { label: 'open', value: ORDER_STATES.OPEN },
  { label: 'closed', value: ORDER_STATES.CLOSED },
  { label: 'removed', value: ORDER_STATES.REMOVED },
]

export const DEFAULT_COMMENTS_PER_PAGE = 5
export const DEFAULT_TOP_HOLDERS_PER_PAGE = 5

export const USER_ACTIVITY_TYPES = {
  ORDER_PLACED: 'order_placed',
  ORDER_RESTED: 'order_rested',
  BOUGHT_SHARES: 'bought_shares',
  SOLD_SHARES: 'sold_shares',
  ORDER_CLOSED: 'order_closed',
  SPLIT: 'split',
  MERGE: 'merge',
  POSITION_RESOLVED: 'position_resolved',
  OPTION_STATE_CHANGED: 'option_state_changed'
}

export const MARKET_OPTION_EMIT_TYPES = {
  OPTION_STATE_CHANGED: 'option_state_changed',
  OPTIONS_CREATED: 'options_created'
}

export const OPTION_STATES = {
  OPEN: 'open',
  CLOSED: 'closed',
  RESOLVED: 'resolved',
  SETTLED: 'settled',
  FILLED: 'filled',
  CANCELLED: 'cancelled'
}

export const USER_POSITION_STATES = {
  OPEN: 'open',
  RESOLVED: 'resolved',
  CANCELLED: 'cancelled'
}

export const POSITION_STATE_FILTERS = [
  { label: 'open', value: USER_POSITION_STATES.OPEN },
  { label: 'resolved', value: USER_POSITION_STATES.RESOLVED },
  { label: 'cancelled', value: USER_POSITION_STATES.CANCELLED },
]

export const NOTIFICATION_CATEGORIES = {
  ORDER: 'order',
  TRADE: 'trade',
  ORDER_COMPLETE: 'order_complete',
  POSITION: 'position',
  RESOLUTION: 'resolution',
  WALLET: 'wallet'
}

export const CRYPTO_ASSETS = ['BTC', 'ETH', 'SOL', 'XRP', 'DOGE']

export const CRYPTO_DURATION_FILTERS = [
  { id: '15m', label: '15 min' },
  { id: '1h', label: 'Hourly' },
  { id: '1d', label: 'Daily' }
]

export const CRYPTO_ASSET_THUMBNAILS = {
  BTC: 'https://upload.wikimedia.org/wikipedia/commons/4/46/Bitcoin.svg',
  ETH: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
  SOL: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png',
  XRP: 'https://s2.coinmarketcap.com/static/img/coins/64x64/52.png',
  DOGE: 'https://s2.coinmarketcap.com/static/img/coins/64x64/74.png'
}